// GA4 provider — wraps react-ga4
// To add a new GA4 parameter mapping, edit the track() method below.
import ReactGA from "react-ga4";

const GA_ID = process.env.REACT_APP_GA_ID ?? "";
const IS_DEV = process.env.NODE_ENV !== "production";

export const ga4 = {
  init() {
    if (!GA_ID) return;
    ReactGA.initialize(GA_ID);
    if (IS_DEV) console.log("[GA4] initialized", GA_ID);
  },

  page(path: string) {
    if (!GA_ID) return;
    if (IS_DEV) console.log("[GA4] page_view →", path);
    ReactGA.send({ hitType: "pageview", page: path });
  },

  track(name: string, params?: Record<string, unknown>) {
    if (!GA_ID) return;
    if (IS_DEV) console.log("[GA4] event →", name, params ?? "");
    ReactGA.event(name, params as Record<string, any>);
  },
};
